import React from "react"
import styled, { ThemeProvider } from "styled-components"

import Spacer from "~/components/Spacer"
import DesktopContainer from "~/components/DesktopContainer"

import Header from "~/components/dashboard/Layout/Header/OldAppHeader"
import Footer from "~/components/dashboard/Layout/Footer/BasicFooter"

const Background = styled.div`
  background: ${props => props.theme.colors.background.page};
  display: flex;
  flex-grow: 1;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  line-height: 1.5rem;
  height: 100%;
`

const GRID_THEME = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 1, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    // container: {
    //   sm: 38,
    //   md: 59,
    //   lg: 61
    // },
    breakpoints: {
      xs: 0,
      sm: 20,
      md: 40,
      lg: 50
    }
  }
}

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Background>
        <DesktopContainer fullHeight>
          <Spacer mobile={20} desktop={20} />
          <ThemeProvider theme={GRID_THEME}>{children}</ThemeProvider>
        </DesktopContainer>
        <Spacer mobile={20} desktop={20} />
      </Background>
      <Footer />
    </>
  )
}

export default Layout
